import React, { useState, useEffect } from "react";
import LineGrouped from "./LineGrouped"; // Assuming LineGrouped.jsx is in the same directory or imported correctly

export const FunctionBar = ({
  isPanelHovered,
  isPanelSticky,
  lastValidHoveredColumn,
  controlsPosition,
  EnhancedTableControlPanel,
  handleTogglePredefinedColumns,
  hoverManager,
  activeColumns,
  contextActions,
  setterFunctions,
  columnVisibility,
  allFilterOptions,
  filters,
  isColumnPinned,
  tableConfig,
  functionBarRef,
  tableId,
}) => {
  const [barDimensions, setBarDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const element = functionBarRef.current;
    if (element) {
      const resizeObserver = new ResizeObserver((entries) => {
        if (entries[0]) {
          const { width, height } = entries[0].contentRect;
          setBarDimensions({ width, height });
        }
      });
      resizeObserver.observe(element);
      setBarDimensions({
        width: element.offsetWidth,
        height: element.offsetHeight,
      });
      return () => {
        if (element) {
          resizeObserver.unobserve(element);
        }
      };
    }
  }, [functionBarRef]);

  const lineGroupedDefaults = {
    circleDiameter: 10,
    lineHeight: 4,
    fixedYPercent: 0,
    lineColor: "bg-[#929FC0]",
    circleColor: "bg-[#929FC0]",
    containerBorderColor: "border-transparent",
    focusRingColor: "focus:ring-blue-500",
    minLineWidth: 30, // Pass minLineWidth
  };

  const fallbackInitialX1 = barDimensions.width > 0 ? Math.max(0, barDimensions.width * 0.1) : 50;
  const fallbackInitialX2 = barDimensions.width > 0
      ? Math.min(
          barDimensions.width - lineGroupedDefaults.circleDiameter,
          barDimensions.width * 0.5 - lineGroupedDefaults.circleDiameter
        )
      : 250;

  return (
    <div ref={functionBarRef} className="function-bar">
      {barDimensions.width > 0 && barDimensions.height > 0 && (
        <LineGrouped
          {...lineGroupedDefaults}
          initialX1={fallbackInitialX1} // Used if localStorage is empty
          initialX2={fallbackInitialX2} // Used if localStorage is empty
          containerWidth={barDimensions.width}
          containerHeight={barDimensions.height}
          storageKey={tableId ? `lineGrouped_${tableId}` : undefined} // Pass storageKey
        />
      )}

      {(hoverManager.hoveredColumn || isPanelHovered || isPanelSticky) && (
        <div
          className={`control-panel-container ${
            activeColumns[hoverManager.hoveredColumn || lastValidHoveredColumn]
              ? "narrow-column-mode"
              : "wide-column-mode"
          }`}
          style={{
            left: controlsPosition.left,
          }}
        >
          <EnhancedTableControlPanel
            key={`panel-${
              hoverManager.hoveredColumn || lastValidHoveredColumn || "default"
            }`}
            columnId={hoverManager.hoveredColumn || lastValidHoveredColumn}
            onToggleColumns={handleTogglePredefinedColumns}
            onToggleEncryption={(newState) =>
              contextActions.setDataEncrypted(newState)
            }
            setterFunctions={setterFunctions}
            onToggleColumnWidth={(columnId, newState) => {
              contextActions.toggleColumnWidth(columnId, newState);
            }}
            isActive={
              activeColumns[
                hoverManager.hoveredColumn || lastValidHoveredColumn
              ] || false
            }
            columnVisibility={columnVisibility}
            setColumnVisibility={contextActions.setColumnVisibility}
            setIsPanelSticky={contextActions.setIsPanelSticky}
            allFilterOptions={allFilterOptions || {}}
            filters={filters}
            setFilters={contextActions.setFilters}
            onPinColumn={contextActions.togglePinnedColumn}
            isPinned={isColumnPinned(hoverManager.hoveredColumn)}
            onSort={(sortObject) => {
              if (sortObject && sortObject.id) {
                contextActions.setSorting([sortObject]);
                contextActions.setIsPanelSticky(false);
              }
            }}
            onResetColumnOrder={() => {
              contextActions.resetColumnOrder(
                tableConfig.columns.map((col) => col.id)
              );
              contextActions.setIsPanelSticky(false);
            }}
            hoverManager={hoverManager}
          />
        </div>
      )}
    </div>
  );
};